import React from "react";
import {
  AllowanceBox,
  ContentBody,
  ContentHeading,
  ContentLayout,
  EmpRound,
} from "../../style";
import {
  Box,
  Col,
  FabButton,
  Flex,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { TbCalendarTime, TbFileTypePdf } from "react-icons/tb";

const EmPortalPayslip = () => {
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Row>
            <Col md={"auto"}>
              <Typography variant="h5" mb="0">
                Payslip Report
              </Typography>
            </Col>
            <Col md={4} lg={2} ml={"auto"}>
              <SelectField
                fullWidth
                label="Financial Year"
                options={[
                  { id: "option1", name: "2023-2024" },
                  { id: "option2", name: "2024-2024" },
                ]}
                defaultValue="fixed"
                placeholder="Select Here..."
              />
            </Col>
          </Row>
        </ContentHeading>

        <ContentBody Padding>
          {/* <Flex gap={20} direction="column">
            <AllowanceBox mb={20}>
              <Row alignItems="center">
                <Col xs={11}>
                  <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                    <Box>
                      <EmpRound>
                        <TbCalendarTime />
                      </EmpRound>
                    </Box>

                    <Box>
                      <Box className="label">December</Box>
                      <Box className="value">05/01/24 - 05/30/24</Box>
                    </Box>
                  </Flex>
                </Col>

                <Col xs={"auto"} ml={"auto"}>
                  <Box>
                    <FabButton
                      size="sm"
                      icon={<TbFileTypePdf />}
                      //    onClick={() => handleEditModalOpen(data)}
                      variant="filled"
                      shape="box"
                    />
                  </Box>
                </Col>
              </Row>
            </AllowanceBox>
          </Flex> */}

          <Row rowGap>
            <Col md={6}>
              <AllowanceBox >
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">January</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        color="danger"
                        icon={<TbFileTypePdf />}
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>
            <Col md={6}>
              <AllowanceBox >
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">February</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                          color="danger"
                        icon={<TbFileTypePdf />}
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>
            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">March</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">April</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">May</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">June</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">July</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">August</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">September</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">October</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">November</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>

            <Col md={6}>
              <AllowanceBox>
                <Row alignItems="center">
                  <Col xs={10}>
                    <Flex alignItems="center" gap={{ md: 20, lg: 30, xxl: 40 }}>
                      <Box>
                        <EmpRound>
                          <TbCalendarTime />
                        </EmpRound>
                      </Box>

                      <Box>
                        <Box className="label">December</Box>
                        <Box className="value">05/01/24 - 05/30/24</Box>
                      </Box>
                    </Flex>
                  </Col>

                  <Col xs={"auto"} ml={"auto"}>
                    <Box>
                      <FabButton
                        size="sm"
                        icon={<TbFileTypePdf />}
                        color="danger"
                        //    onClick={() => handleEditModalOpen(data)}
                        variant="filled"
                        shape="box"
                      />
                    </Box>
                  </Col>
                </Row>
              </AllowanceBox>
            </Col>
          </Row>
        </ContentBody>
      </ContentLayout>
    </>
  );
};

export default EmPortalPayslip;
